import { Avatar } from "@offstreetparking/design-system/dataDisplay/Avatar";
import { Text } from "@offstreetparking/design-system/typography";

export const TopBarUserDetails = ({
	displayName,
	firstName,
	lastName,
	email,
}: { displayName: string; firstName: string | null; lastName: string | null; email: string }) => {
	return (
		<div className="flex items-center gap-3 p-4">
			<Avatar firstName={firstName} lastName={lastName} variant="filled" />
			<div className="min-w-0">
				<Text className="truncate" weight="bold">
					{displayName}
				</Text>
				{email && (
					<Text className="truncate" size="sm" intent="muted">
						{email}
					</Text>
				)}
			</div>
		</div>
	);
};
